import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

import "./i18n/config";
import SetupParamsHelper from "./helpers/SetupParamsHelper.ts";

ReactDOM.createRoot(
  document.getElementById(SetupParamsHelper.getSetupParams().EmbedId)!
).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const getBrowserLanguage = () => {
  const languages = navigator.languages || [navigator.language || "en"];
  return languages[0] || "en";
};

document.documentElement.lang = getBrowserLanguage();
